// FAQ guide: sticky numbered nav built from the group sections on the page, plus question search.
(() => {
  if (window.__fqgInit) return;
  window.__fqgInit = true;

  const init = () => {
    const groups = [...document.querySelectorAll('.fqg-group')];
    const navWrap = document.querySelector('[data-fqg-nav]');
    const nav = navWrap && navWrap.querySelector('.fqg-nav');
    const list = nav && nav.querySelector('ol');
    const header = document.querySelector('.section-header');
    const stickyHeader = document.querySelector('sticky-header');
    let links = [];

    // Nav: one link per group, numbered in page order.
    // Fixed numbers, so they don't shift when search hides a group.
    groups.forEach((g, i) => {
      const badge = g.querySelector('.fqg-group__num');
      if (badge) badge.textContent = String(i + 1).padStart(2, '0');
    });

    if (list) {
      list.innerHTML = '';
      links = groups.map((g, i) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + g.id;
        const num = document.createElement('span');
        num.textContent = String(i + 1).padStart(2, '0');
        a.append(num, document.createTextNode(g.dataset.navLabel || g.querySelector('h2').textContent));
        li.append(a);
        list.append(li);
        a.addEventListener('click', (e) => {
          e.preventDefault();
          if (stickyHeader) stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
          g.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          history.replaceState(null, '', a.hash);
        });
        return a;
      });
    }

    // Sit under the site header while it's showing, move to the top when it hides.
    const stickTarget = navWrap && (navWrap.closest('.shopify-section') || navWrap);
    const place = () => {
      if (!stickTarget) return;
      const shown = header && header.classList.contains('shopify-section-header-sticky') && !header.classList.contains('shopify-section-header-hidden');
      stickTarget.style.top = shown ? header.offsetHeight + 'px' : '0px';
      document.documentElement.style.setProperty('--fqg-nav-h', stickTarget.offsetHeight + 'px');
    };
    if (header) new MutationObserver(place).observe(header, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', place);
    place();

    // Highlight the last visible group whose top has passed just under the nav.
    let current = -1;
    let ticking = false;
    const update = () => {
      ticking = false;
      if (!links.length) return;
      const line = (stickTarget ? stickTarget.getBoundingClientRect().bottom : 0) + 80;
      let idx = -1;
      groups.forEach((g, i) => { if (!g.hidden && g.getBoundingClientRect().top <= line) idx = i; });
      if (idx === current) return;
      current = idx;
      links.forEach((a, i) => a.setAttribute('aria-current', i === idx ? 'true' : 'false'));
      if (idx >= 0) list.scrollTo({ left: links[idx].parentElement.offsetLeft - 16, behavior: 'smooth' });
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();

    // Search: filter questions by every word typed, across question and answer text.
    const input = document.querySelector('[data-fqg-search]');
    const clear = document.querySelector('[data-fqg-clear]');
    const status = document.querySelector('[data-fqg-status]');
    const items = groups.flatMap((g) => [...g.querySelectorAll('details')]);
    items.forEach((d) => {
      const g = d.closest('.fqg-group');
      const topic = (g.dataset.navLabel || '') + ' ' + g.querySelector('h2').textContent;
      d.dataset.defaultOpen = d.open ? '1' : '';
      d.dataset.search = (topic + ' ' + d.textContent).toLowerCase().replace(/\s+/g, ' ');
    });
    const noResults = status ? status.innerHTML : '';
    const run = () => {
      const q = input.value.trim().toLowerCase();
      const words = q.split(/\s+/).filter(Boolean);
      clear.hidden = !q;
      let shown = 0;
      items.forEach((d) => {
        const hit = words.every((w) => d.dataset.search.includes(w));
        d.hidden = !hit;
        d.open = q ? hit : d.dataset.defaultOpen === '1';
        if (hit) shown++;
      });
      groups.forEach((g, i) => {
        const any = [...g.querySelectorAll('details')].some((d) => !d.hidden);
        g.hidden = !any;
        if (links[i]) links[i].parentElement.hidden = !any;
      });
      if (status) {
        if (!q) status.textContent = '';
        else if (shown) status.textContent = shown + (shown === 1 ? ' question matches' : ' questions match') + ' “' + input.value.trim() + '”';
        else status.innerHTML = noResults;
        status.hidden = !q;
      }
      current = -1;
      update();
    };
    if (input && clear) {
      if (status) { status.textContent = ''; status.hidden = true; }
      input.addEventListener('input', run);
      input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { input.value = ''; run(); } });
      clear.addEventListener('click', () => { input.value = ''; run(); input.focus(); });
    }

    // Deep links to a question (e.g. /pages/faq#do-you-have-samples) open it.
    const openFromHash = () => {
      const el = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (el && el.tagName === 'DETAILS') { el.open = true; el.scrollIntoView(); }
    };
    window.addEventListener('hashchange', openFromHash);
    openFromHash();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
